<template lang="html">
    <div class="tab-content deal-documents" v-loader-overlay="progressDocs">
        <z-modal-sidebar ref="sidebar" v-bind:title="previewDocument.title" v-on:hide="closeDoc">
            <doc
                v-bind:document="previewDocument"
                v-bind:deal="deal"
                v-on:refresh-doc="getDocs(true)"
                v-bind:removable="canRemove(previewDocument)"
            ></doc>
        </z-modal-sidebar>
        <span v-if="!isDealFilled">Создание документов доступно после заполнения заявки</span>
        <div class="deal-docs" v-if="isDealFilled && customersDocs && Object.values(customersDocs).length">
            <toggle-card
                class="deal-docs__customer"
                v-for="customer in Object.values(customersDocs)" v-bind:key="('doc-customer-' + customer.id)"
                v-bind:heading="customer.name + (customer.removed ? ' <font style=\'color: red;\'>(архив)<font>' : '')"
                v-bind:visibility="customer.visibility"
            >
                <template slot="actions">
                    <md-menu
                        md-direction="bottom-start"
                        v-if="isDealFilled && !hasDocs(['bill', 'invoice_a4', 'assignment', 'receipt', 'act_a4', 'stock_note']) && !$props.block"
                    >
                        <z-button md-menu-trigger square v-on:click.stop.prevent="" v-if="!customer.removed">
                            <md-tooltip md-direction="bottom" md-delay="200">Добавить документ</md-tooltip>
                            <md-icon>add</md-icon>
                        </z-button>
                        <md-menu-content>
                            <md-menu-item v-if="customer.main" v-bind:disabled="!!getDoc('receipt', customer.id)"    v-on:click="saveDocument(['receipt'], customer.id)">Экспедиторская расписка</md-menu-item>
                            <md-menu-item v-if="customer.main" v-bind:disabled="!!getDoc('stock_note', customer.id)" v-on:click="saveDocument(['stock_note'], customer.id)">Складская записка</md-menu-item>

                            <hr class="md-list-divider" />

                            <md-menu-item v-bind:disabled="!!getDoc('bill', customer.id)" v-on:click="saveDocument(['bill'], customer.id)">Счёт</md-menu-item>

                            <!-- //Акт + Счёт-фактура для НДС -->
                            <md-menu-item
                                v-on:click="saveDocument(['act_a4', 'invoice_a4'], customer.id), customer.id"
                                v-bind:disabled="!deal.executor || parseInt(deal.executor.nds) !== 1 || (!!getDoc('invoice_a4', customer.id) && !!getDoc('act_a4', customer.id))"
                            >Счёт фактура и акт</md-menu-item>

                            <!--
                            // Принципал может быть только БЕЗ НДС
                            // Счёт-фактура создаётся только С НДС
                            //
                            // Для НДС:
                            // Счёт-фактура создаётся только вместе с актом
                            // Акт создаётся только вместе с Счётом-фактурой
                            -->
                            <!-- //Акт для БЕЗ НДС -->                            
                            <md-menu-item
                                v-on:click="saveDocument(['act_a4'], customer.id)"
                                v-bind:disabled="(!deal.executor || parseInt(deal.executor.nds) === 1 || !!getDoc('act_a4', customer.id))"
                            >Акт</md-menu-item>

                            <md-menu-item
                                v-on:click="showAgentDialog(['act_a4'], customer.id)"
                                v-bind:disabled="(!deal.executor || parseInt(deal.executor.nds) === 1 || !!getDoc('act_a4', customer.id))"
                            >Акт (принципал)</md-menu-item>

                            <hr class="md-list-divider" />

                            <md-menu-item v-bind:disabled="!deal.executor || !!getDoc('act_a4', customer.id, ['storage'])" v-on:click="saveDocument(['act_a4'], customer.id, null, ['storage'])">Акт (хранение)</md-menu-item>
                            <md-menu-item v-bind:disabled="!deal.executor || !!getDoc('bill', customer.id, ['storage'])"   v-on:click="saveDocument(['bill'], customer.id, null, ['storage'])">Счёт (хранение)</md-menu-item>
                            <md-menu-item
                                v-on:click="saveDocument(['act_a4', 'invoice_a4'], customer.id, null, ['storage']), customer.id"
                                v-bind:disabled="!deal.executor || parseInt(deal.executor.nds) !== 1 || (!!getDoc('invoice_a4', customer.id, ['storage']) && !!getDoc('act_a4', customer.id, ['storage']))"
                            >Счёт фактура и акт (хранение)</md-menu-item>
                            
                        </md-menu-content>
                    </md-menu>
                </template>

                <div class="md-content md-theme-white" v-if="!customer.docs || !customer.docs.length">Документы не созданны</div>
                <div class="md-table md-theme-white" v-if="customer.docs.length">
                    <div class="md-table-content">
                        <table>
                            <thead>
                                <tr class="md-table-row">
                                    <th class="md-table-head">
                                        <div class="md-table-head-container">
                                            <div class="md-table-head-label"></div>
                                        </div>
                                    </th>
                                    <th class="md-table-head">
                                        <div class="md-table-head-container">
                                            <div class="md-table-head-label">№</div>
                                        </div>
                                    </th>
                                    <th class="md-table-head">
                                        <div class="md-table-head-container">
                                            <div class="md-table-head-label">Документ</div>
                                        </div>
                                    </th>
                                    <th class="md-table-head">
                                        <div class="md-table-head-container">
                                            <div class="md-table-head-label">Создан</div>
                                        </div>
                                    </th>
                                    <th class="md-table-head">
                                        <div class="md-table-head-container">
                                            <div class="md-table-head-label">Последняя печать</div>
                                        </div>
                                    </th>
                                    <th class="md-table-head">
                                        <div class="md-table-head-container">
                                            <div class="md-table-head-label">Последняя отправка</div>
                                        </div>
                                    </th>
                                    <th class="md-table-head">
                                        <div class="md-table-head-container">
                                            <div class="md-table-head-label">Принципал</div>
                                        </div>
                                    </th>
                                    <th class="md-table-head">
                                        <div class="md-table-head-container">
                                            <div class="md-table-head-label"></div>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    class="md-table-row"
                                    v-for="doc in customer.docs"
                                    v-bind:key="('doc-customer-' + customer.id + '-' + doc.id)"
                                    v-bind:class="{'deleted': (doc.status == 'DELETED')}"
                                >
                                    <md-tooltip v-if="doc.status == 'DELETED'" md-direction="bottom" md-delay="200">
                                        {{ 'Этот документ был удалён ' + moment(doc.updated_at).tz($root.userTimezone).format('DD.MM.YYYY в HH:mm') }}
                                    </md-tooltip>

                                    <td class="md-table-cell">
                                        <div class="md-table-cell-container">
                                            <z-check
                                                class="deal-docs-select"
                                                v-if="doc.status == 'ACTUAL'"
                                                v-bind:name="('doc-select-' + doc.id)"
                                                v-bind:id="('doc-select-' + doc.id)"
                                                v-model="selectDocuments"
                                                v-bind:value="doc.id"
                                            ></z-check>
                                        </div>
                                    </td>

                                    <td class="md-table-cell" @click="previewDoc(doc)">
                                        <div class="md-table-cell-container" v-if="labels[doc.type]">{{ getDocNumber(doc) }}</div>
                                    </td>
                                    <td class="md-table-cell" @click="previewDoc(doc)">
                                        <div class="md-table-cell-container" v-html="getDocLabel(doc)"></div>
                                    </td>
                                    <td class="md-table-cell" @click="previewDoc(doc)">
                                        <div class="md-table-cell-container" v-if="doc.created_at">
                                            <div>{{ moment(doc.created_at).tz($root.userTimezone).format('DD.MM.YYYY HH:mm') }}</div>
                                            <md-tooltip md-direction="bottom" md-delay="200">
                                                {{ ((doc.creater && doc.creater.login) ? (doc.creater.fio || doc.creater.login) :  'клиент') }}
                                            </md-tooltip>
                                        </div>
                                    </td>
                                    <td class="md-table-cell" @click="previewDoc(doc)">
                                        <div class="md-table-cell-container" v-if="doc.updated_at">
                                            <div v-if="doc.last_print_date">
                                                {{ moment(doc.last_print_date).tz($root.userTimezone).format('DD.MM.YYYY') }}
                                            </div>
                                            <div v-else>--</div>
                                            <md-tooltip md-direction="bottom" md-delay="200" v-if="doc.last_print_date">
                                                {{ ((doc.last_printer && doc.last_printer.login) ? (doc.last_printer.fio || doc.last_printer.login) : 'клиент') }}
                                            </md-tooltip>
                                        </div>
                                    </td>
                                    <td class="md-table-cell" @click="previewDoc(doc)">
                                        <div class="md-table-cell-container" v-if="doc.last_email && doc.last_email.user">
                                            <span>
                                                {{ moment(doc.last_email.created_at).tz($root.userTimezone).format('DD.MM.YYYY') }},
                                                {{ doc.last_email.success == '1' ? 'доставлено' : 'не доставлено' }}                                                
                                            </span>
                                            <md-tooltip md-direction="bottom" md-delay="200">
                                                Отправлено {{ (doc.last_email.user.fio || doc.last_email.user.login) }} ({{ doc.last_email.user.id }}) на {{ doc.last_email.email }}
                                            </md-tooltip>
                                        </div>
                                        <div class="md-table-cell-container" v-else>--</div>
                                    </td>
                                    <td class="md-table-cell" @click="previewDoc(doc)">
                                        <div class="md-table-cell-container" v-if="doc.agent && doc.agent.id">
                                            {{doc.agent.name + ((doc.agent.inn) ? (', ' + doc.agent.inn) : ((doc.agent.passport_number) ? (', ' + doc.agent.passport_number) : '') ) }}
                                        </div>
                                        <div class="md-table-cell-container" v-else></div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        
                    </div>
                </div>
            </toggle-card>
        </div>

        <md-button
            v-if="selectDocuments.length > 0"
            v-on:click="sendDocDialog = true"
            class="md-primary md-raised md-dense mass-action"
        >
            <span>Отправить на E-mail</span>
            <md-icon>email</md-icon>
        </md-button>

        <ZDialog v-bind:active.sync="agentDialog">
            <template slot="title">Укажите принципала</template>
            <template>
                <div>Внимание, указание принципала возможно только для исполнителя без НДС</div>
                <div>Убедитесь в корректности выбора исполнителя</div>
                <z-select
                    id="agent_id" name="agent_id" label="Принципал" v-model="agent_id"
                    data-vv-scope="agent" data-vv-as=" " data-vv-name="agent_id"
                    v-validate="'required'"  v-bind:error="errors.first('agent.agent_id')"
                >
                    <option
                        v-for="item in agents"
                        v-bind:key="item.id"
                        v-bind:value="item.id"
                    >{{ item.label }}</option>
                </z-select>
            </template>
            <template slot="actions">
                <z-button @click="agentDialog = false">Отмена</z-button>
                <z-button @click="saveDocumentWithAgent()" accent>Сохранить</z-button>
            </template>
        </ZDialog>

        <ZDialog v-bind:active.sync="sendDocDialog">
            <template slot="title">Отправка документа</template>
            <template>
                <z-select
                    id="document-recipient"
                    name="document_recipient"
                    label="E-mail получателя"
                    v-validate="'required'"
                    v-bind:error="errors.first('document_recipient')"
                    v-model="documentRecipient"
                >
                    <option v-for="contact in contacts" v-bind:key="contact.id" v-bind:value="contact.id">
                        {{ contact.email }} {{ contact.type_name ? '(' + contact.type_name + ')' : '' }}
                    </option>
                    <option value="other">Другой...</option>
                </z-select>
                <z-input
                    label="Ваш e-mail"
                    v-if="documentRecipient == 'other'"
                    v-model="documentRecipientOther"
                    name="document_recipient_other"
                    id="document-recipient-other"
                    v-validate="'email|required'"
                    v-bind:error="errors.first('document_recipient_other')"
                    data-vv-name="document_recipient_other"
                    v-bind:data-vv-as="' '"
                ></z-input>
            </template>
            <template slot="actions">
                <z-button @click="sendDocDialog = false">Отмена</z-button>
                <z-button @click="sendDoc()" accent>Отправить</z-button>
            </template>
        </ZDialog>
    </div>
</template>
<script>
    import ZSelect from '@/components/ZSelect';
    import ZInput  from '@/components/ZInput';
    import ZButton from '@/components/ZButton';
    import ZCheck  from '@/components/ZCheck';
    import ZDialog from '@/components/ZDialog';
    import ZModalSidebar from '@/components/ZModalSidebar';
    import ToggleCard    from '@/components/ToggleCard';
    import Doc from './Doc';
    export default {
        name: 'docs',
        props: {
            deal: {
                type: Object,
                default: () => {}
            },
            freight: {
                type: Object,
                default: () => ({
                    id: null
                })
            },
            load: {
                type: Boolean,
                default: false
            },
            block: {
                type: Boolean,
                default: false
            },
            finance: {
                type: Array,
                default: []
            },
        },
        components: {
            ZSelect, ZModalSidebar, ZDialog, ZInput, ToggleCard, ZButton, ZCheck, Doc
        },
        data() {
            return {
                loaderName: 'load-deal-docs-card',
                nds: false,
                agents: [],
                agent_id: null,
                customerId: null,
                docType: [],
                documents: [],
                agentDialog: false,
                sendDocDialog: false,
                documentRecipient: '',
                documentRecipientOther: '',
                selectDocuments: [],
                //Типы способов оплаты, при которых нельзя удалять акт
                immutablePaymentMethodsTypes: [3,5,6],

                previewDocument: {
                    url: '',
                    id: null,
                    deal_id: null,
                    type: null,
                    user_id: null,
                    last_print_date: null,
                    last_print_user_id: null,
                    created_at: null,
                    updated_at: null,
                    data: null,
                    agent_id: null,
                    executor_id: null,
                    number: null,
                    last_printer: null,
                    status: null,
                    status_name: '',
                },
                docs: {
                    bill: false,
                    invoice_a4: false,
                    assignment: false,
                    receipt: false,
                    act_a4: false,
                },
                labels: {
                    bill:       'Счёт',
                    invoice_a4: 'Счёт фактура',
                    assignment: 'Поручение экспедитору',
                    receipt:    'Экспедиторская расписка',
                    act_a4:     'Акт выполненных работ',
                    stock_note: 'Складская записка',
                    route_list: 'Маршрутный лист'
                },
                // Трекинги, обязательные для создания отчёных документов
                requiredTrakings: ['storekeeper_accepted_from_client', 'storekeeper_adopted_at_sorting_center'],
                trackings: []
            }
        },
        computed: {
            progressDocs() {
                return this.progressObj[this.loaderName];
            },
            progressObj() {
                return this.$store.state.progressObj;
            },
            isDealFilled() {
                if (this.$props.deal && this.$props.deal.filled) return true;
                return false;
            },
            // Проверяет есть ли у заявки услуга сверхнормативного хранения
            isDealHasStorage() {
                return (
                    this.$props.deal &&
                    this.$props.deal.firstFreight &&
                    this.$props.deal.firstFreight.full_price &&
                    this.$props.deal.firstFreight.full_price.additional &&
                    this.$props.deal.firstFreight.full_price.additional.storage &&
                    parseInt(this.$props.deal.firstFreight.full_price.additional.storage.value) > 0
                )
            },
            actualDocs() {
                if (!this.documents || !this.documents.length) return [];
                return this.documents.filter(doc => doc.status == 'ACTUAL');
            },
            deletedDocs() {
                if (!this.documents || !this.documents.length) return [];
                return this.documents.filter(doc => doc.status == 'DELETED');
            },
            customersDocs() {
                let Result = {};
                if (!this.$props.deal || !this.$props.deal.payer || !this.$props.deal.payer.id) return Result;

                Result[this.$props.deal.payer.id] = Object.assign({}, this.$props.deal.payer);
                Result[this.$props.deal.payer.id]['docs'] = [];
                Result[this.$props.deal.payer.id]['visibility'] = false;
                Result[this.$props.deal.payer.id]['main']    = true;
                Result[this.$props.deal.payer.id]['removed'] = false;

                if (this.$props.deal.payers) this.$props.deal.payers.map(payer => {
                    if (payer.value && payer.value.id && !Result[payer.value.id]) {
                        Result[payer.value.id] = Object.assign({}, payer.value);
                        Result[payer.value.id]['docs'] = [];
                        Result[payer.value.id]['visibility'] = false;
                        Result[payer.value.id]['main'] = false;
                    }
                });

                if (!this.documents || !this.documents.length) return Result;
                
                this.documents.map(doc => {
                    //Если контрагента ещё нет в списке, значит он удалён из заявки, но его документы в заявке есть
                    if (doc.customer_id && !Result[doc.customer_id]) {
                        Result[doc.customer_id] = Object.assign({}, doc.customer);
                        Result[doc.customer_id]['docs'] = [];
                        Result[doc.customer_id]['visibility'] = false;
                        Result[doc.customer_id]['main']    = false;
                        Result[doc.customer_id]['removed'] = true;
                    }

                    if (doc && doc.customer_id && Result[doc.customer_id]) {
                        let item = Object.assign({}, doc);
                        item.sort = (item.status && item.status == 'ACTUAL') ? 0 : 1;
                        delete item.customer;
                        Result[doc.customer_id]['docs'].push(item);
                        Result[doc.customer_id]['visibility'] = true;
                    }
                });

                return Object.values(Result).map(Customer => {
                    Customer.docs = Customer.docs.sort((a,b) => {
                        if (a.sort < b.sort) return -1;
                        if (a.sort > b.sort) return 1;
                        return 0;
                    });
                    return Customer;
                })
            },
            companies() {
                return this.$store.state.companies.companies;
            },
            user() {
                return this.$store.state.users.current;
            },
            isUserManager() {
                return (this.user && this.user.groups_codes) ? !!(this.user.groups_codes.indexOf('managers')+1) : false;
            },
            isUserAgent() {
                return (this.user && this.user.groups_codes) ? !!(this.user.groups_codes.indexOf('agent')+1) : false;
            },
            isUserAgentForm() {
                return (this.$route.query && this.$route.query.agent) ? true : false;
            },
            minDocDate() {
                if (!this.$props.deal || !this.$props.deal.created_at) return;
                else return this.moment(this.$props.deal.created_at).tz(this.$root.userTimezone).format('YYYY-MM-DD HH:mm:ss');
            },
            maxDocDate() {
                if (!this.$props.deal || !this.$props.deal.first_freight || !this.$props.deal.first_freight.issuedtracking || !this.$props.deal.first_freight.issuedtracking.date) return;
                else return this.moment(this.$props.deal.first_freight.issuedtracking.date).tz(this.$root.userTimezone).format('YYYY-MM-DD HH:mm:ss');
            },
            contacts() {
                let contacts = [];
                let members = ['sender', 'recipient', 'payer'];
                members.forEach(member => {
                    if (
                        this.deal &&
                        typeof this.deal[member] !== 'undefined' &&
                        this.deal[member] != undefined &&
                        this.deal[member] &&
                        this.deal[member].email &&
                        this.deal[member].email.length > 0
                    ) {
                        contacts.push({
                            id: member,
                            email: this.deal[member].email,
                            name: null,
                            type: member
                        });
                    }
                });

                this.deal.contacts.forEach(contact => {
                    if (contact.contact.email && contact.contact.email.length > 0) {
                        contact.contact.type = contact.type;
                        contact.contact.id = contact.id;
                        contacts.push(contact.contact);
                    }
                });

                contacts.forEach(contact => {
                    contact.type_name = '';
                    switch (contact.type) {
                        case 'sender': contact.type_name = 'отправитель'; break;
                        case 'recipient': contact.type_name = 'получатель'; break;
                        case 'payer':
                            contact.type_name = 'плательщик';
                            if (contact.type == 'payer') this.documentRecipient = contact.id;
                            break;
                    }
                });

                return contacts;
            },
            //Способы оплаты, при которых нельзя удалять акт
            immutablePaymentMethods() {
                return this.$store.state.cost.payment_methods.filter(item => {
                    return (this.immutablePaymentMethodsTypes.indexOf(parseInt(item.type)) + 1);
                }).map(item => item.id);
            },
            hasRequiredTrakings() {
                if (!this.trackings || !Array.isArray(this.trackings) || !this.trackings.length) return false;
                return !!this.trackings.find(item => item && item.status && item.status.code && this.requiredTrakings.indexOf(item.status.code) + 1)
            }
        },
        watch: {
            'documents': {
                deep: true,
                handler() {}
            },
            'customersDocs': {
                deep: true,
                handler() {}
            },
            '$props.deal.id'() {
                this.getDocs();
                this.checkNDS();
            },
            '$props.load'(load) {
                if (load) {
                    this.getDocs();
                    this.getTrackings();
                }
            }
        },
        methods: {
            getDocLabel(doc) {
                let label = doc.type && this.labels[doc.type] ? this.labels[doc.type] : '', servicesLable = ''

                if (doc.payer_services) servicesLable = doc.payer_services.map(item => item.name).join(', ')
                if (doc.payerServices)  servicesLable = doc.payerServices.map(item => item.name).join(', ')
                if (servicesLable) label += ` (${servicesLable})`

                return label
            },
            getDocs(refreshPreview) {
                if (!this.$props.deal || !this.$props.deal.id) return;
                this.$store.commit('showProgressBar', this.loaderName);
                this.$store.dispatch('deals/getDocuments', this.$props.deal.id).then(docs => {
                    this.documents = Object.assign([], docs);
                    this.$emit('update', this.documents);
                }).catch(() => null).finally(() => {
                    this.$store.commit('hideProgressBar', this.loaderName);
                    if (typeof refreshPreview !== 'undefined' && refreshPreview && this.previewDocument.id) 
                        this.previewDoc(this.documents.find(document => document.id == this.previewDocument.id));
                });
            },
            getDocNumber(doc) {
                if (!doc) return 0;
                if (doc.type !== 'bill') return doc.number;
                if (!doc.number_in_deal || parseInt(doc.number_in_deal) <= 0)
                    return this.deal.first_freight.traking_number;

                return `${this.deal.first_freight.traking_number}/${doc.number_in_deal}`;
            },
            getTrackings() {
                if (!this.$props.freight || !this.$props.freight.id || this.$props.freight.id == 'new') return
                return this.$store.dispatch('stock/getFreightTracking', {
                    page: 1,
                    count:      'all',
                    order_by:   'id',
                    order_type: 'desc',
                    filter: {
                        model:    [['freight_id', '=', this.$props.freight.id]],
                        relation: [['status', 'code', '=', this.requiredTrakings]],
                        condition: 'and'
                    }
                }).catch(() => null).then(r => {
                    if (r && r.data) this.trackings = Object.assign([], r.data)
                    else this.trackings = Object.assign([], [])
                });
            },
            canRemove(doc) {
                if (!doc || !doc.type || !this.$props.finance || !this.$props.finance.length) return true;
                if (doc.type != 'act_a4' && doc.type != 'invoice_a4') return true;
                
                return !this.$props.finance
                    .filter(finance => parseInt(finance.customer_id) == parseInt(doc.customer_id))
                    .find(finance => {
                        return ( this.immutablePaymentMethods.indexOf(parseInt(finance.payment_method_id)) + 1);
                    });
            },
            toggleDocTypeList() {
                this.showDocTypeList = !this.showDocTypeList;
            },
            //сохранение документов
            saveDocument(docType, customer_id = null, agent_id = null, services = []) {
                if (this.progressDocs) return new Promise((resolve) => resolve());
                this.$store.commit('showProgressBar', this.loaderName);
                return this.$store.dispatch('deals/postDocument', {
                    deal_id: this.$props.deal.id,
                    user_id: this.user.id,
                    agent_id:    (agent_id)    ? agent_id    : null,
                    customer_id: (customer_id) ? customer_id : null,
                    documents: Object.assign([], docType),
                    services:  Object.assign([], services)
                }).then(docs => {
                    if (!docs || !docs.length) return [];
                    docs.map(doc => {
                        this.documents.push(doc);
                        this.$store.commit('showSnackbar', [`Документ "${this.getDocLabel(doc)}" успешно сохранён`, 6000, 'success']);
                    });
                    this.$emit('update', this.documents);
                    return docs;
                }).catch(() => null).finally(() => this.$store.commit('hideProgressBar', this.loaderName));
            },
            saveDocumentWithAgent() {
                this.$validator.validateAll('agent').then(valid => {
                    if (!valid || this.progressDocs) return;
                    this.saveDocument(this.docType, this.customerId, this.agent_id).then(() => {
                        this.docType = [];
                        this.agent_id = null;
                        this.agentDialog = false;
                    }).catch(() => null);
                });
            },
            showAgentDialog(docType, customerId) {
                this.agentDialog = true;
                this.docType     = Object.assign([], docType);
                this.customerId  = customerId;
            },
            checkNDS() {
                if (
                    !this.$props.deal || 
                    !this.$props.deal.id || 
                    !this.$props.deal.executor_company_id ||
                    !this.companies || 
                    !this.companies.length
                ) {
                    this.nds = false;
                    return;
                }
                let executor;
                this.companies.map(company => { if (parseInt(company.id) == parseInt(this.$props.deal.executor_company_id)) executor = company;});
                if (!executor) {
                    this.nds = false;
                    return;
                }
                this.nds = parseFloat(executor.nds);
            },
            previewDoc(document) {
                if (!document || !this.$refs || !this.$refs.sidebar) return; 
                this.$refs.sidebar.$emit('show');
                document.title = `${this.getDocLabel(document)} №${this.getDocNumber(document)}, заявка ${this.deal.first_freight.traking_number}`;
                this.previewDocument = Object.assign({}, document);
            },
            closeDoc() {
                this.previewDocument.id = null;
            },
            hasDocs(types) {
                let result = {};
                if (!types || !types.length || !this.documents || !this.documents.length) return false;

                let item = null;
                types.map(type => {
                    item = null;
                    item = this.documents.find(doc => doc.type == type && doc.status == 'ACTUAL');
                    if (item) result[type] = item;
                });
                
                return types.length == Object.keys(result).length;
            },
            getDoc(type, customerId = null, services = []) {
                if (
                    ['act', 'act_a4', 'bill', 'invoice_a4'].indexOf(type)+1 &&
                    (!this.$props.deal || !this.$props.deal.status || this.$props.deal.status.type !== 'confirmed')
                ) return true;
                if (['act', 'act_a4', 'invoice_a4'].indexOf(type) + 1 && !this.hasRequiredTrakings) return true;

                if (!this.documents || !this.documents.length) return false;
                return this.documents.find(doc => {
                    let DocServices = null;
                    if (doc.payer_services) DocServices = doc.payer_services.map(i => i.code)
                    else if (doc.payerServices) DocServices = doc.payerServices.map(i => i.code)
                    return (
                        doc.type == type &&
                        parseInt(doc.customer_id) === parseInt(customerId) &&
                        doc.status == 'ACTUAL' &&
                        JSON.stringify(DocServices) === JSON.stringify(services)
                    )
                });
            },
            listeners() {
                this.$root.$on('update-deal-documents', id => {
                    if (this.$props.deal && parseInt(id) === parseInt(this.$props.deal.id))
                        this.getDocs(true);
                });
            },
            getAgents() {
                return this.$store.dispatch('customers/getCustomers', {
                    page: 1, order_by: 'id', order_type: 'asc', count: 'all',
                    filter: {model: [['is_agent', '=', 1]], relation: []}, cache: true
                }).catch(() => null).then(r => {
                    if (r && r.length) this.agents = Object.assign([], r.map(item => {
                        return {
                            id: item.id,
                            label: ((item.inn) ? (item.inn + ': ') : ((item.passport_number) ? (item.passport_number + ': ') : '')) + item.name
                        };
                    }));
                });
            },
            sendDoc() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;

                    const data = {
                        documents: this.selectDocuments
                    };
                    if (this.documentRecipient == 'other') {
                        data.email = this.documentRecipientOther;
                    } else {
                        const contact = this.contacts.find(contact => contact.id == this.documentRecipient);

                        data.email = contact.email;
                        if (contact.name) data.name = contact.name;
                    }
                    
                    this.sendDocDialog = false;

                    this.$store.commit('showProgressBar', this.loaderName);
                    this.$store.dispatch('deals/sendDocumentsByEmail', data).then(result => {
                        if (result.success) this.$store.commit('showSnackbar', ['Документы отправлены', 10000, 'success']);
                    }).catch(() => null).finally(() => this.$store.commit('hideProgressBar', this.loaderName));
                });
            },
        },
        created() {
            this.checkNDS();
            this.getTrackings();
            this.getDocs();
            this.getAgents();
            this.listeners();
        },
    }
</script>
<style scoped lang="sass">
.deal-documents
    .add-btn
        margin: 0 0 10px 0
    .documents
        margin: 0 0 10px 0
        .md-subheading
            margin: 0 0 0 0
        .md-layout
            border-bottom: 1px solid rgba(0, 0, 0, 0.42)
            padding: 5px 0
            align-items: flex-start
            &:last-child
                border: 0
            .button-container
                width: 400px
                display: flex
                align-items: center
                justify-content: flex-start
                .print-btn
                    width: calc(100% - 120px)
                    flex-shrink: 1
                .icon-btn
                    min-width: 32px
                    watch: 32px
                    height: 32px
                    padding: 0
                    flex-shrink: 0
        button
            margin: 0 10px 0 0
    .mass-action
        margin: 0
        span
            margin: 0 8px 0 0


    .deal-docs
        .deal-docs-select
            display: flex
            align-items: center
            justify-content: center
            margin: 0
        .md-table
            tr.md-table-row
                cursor: pointer
                th.md-table-head 
                    .md-table-head-container
                        padding: 6px 0 0 0
                        height: auto
                        .md-table-head-label
                            height: auto
                            line-height: 16px
                            padding: 0 4px
                .md-table-cell
                    height: auto
                    .md-table-cell-container
                        padding: 4px
                    .actions
                        display: flex
                        align-items: center
                        justify-content: flex-end
                &.deleted
                    color: red
</style>


// WEBPACK FOOTER //
// Docs.vue?9a41b934